import Table from '../../../../components/table/Table';

import useContentsUnitsAnalysis from './useContentsUnitsAnalysis';

const ContentsUnitsAnalysis = () => {
  const { data, columns, isLoading, onClickOnUnit } =
    useContentsUnitsAnalysis();

  return (
    <Table
      data={data}
      columns={columns}
      onRowClick={onClickOnUnit}
      isLoading={isLoading}
      testId='content-units-table'
    />
  );
};

export default ContentsUnitsAnalysis;
